var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 control-section"},[_c('div',{staticClass:"tree-control-wrapper"},[_c('ejs-treeview',{ref:"measureTreeForDataSearch",attrs:{"id":"measureTreeForDataSearch","fields":_vm.fieldsForDataSearch,"showCheckBox":true,"nodeChecked":_vm.nodeCheckedOfMeasureTreeForDataSearch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }